import {
  Button,
  HStack,
  InputGroup,
  Modal,
  ModalBody,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  NumberDecrementStepper,
  NumberIncrementStepper,
  NumberInput,
  NumberInputField,
  NumberInputStepper,
  Stack,
  Text,
} from "@chakra-ui/react";
import { EventDetailAffiliatesSection } from "@common/interfaces/KYDEvent";
import { Controller, useForm } from "react-hook-form";

type AddAffiliateValues = {
  quantity: number;
};

const AddAffiliateModal = ({
  data,
  onClose,
  isLoading,
  isOpen = false,
  onCreateAffiliates,
}: {
  data: EventDetailAffiliatesSection["data"];
  isOpen?: boolean;
  onClose: () => void;
  isLoading: boolean;
  onCreateAffiliates: (values: { quantity: number }) => void;
}) => {
  const {
    handleSubmit,
    setValue,
    control,
    reset,
    formState: { isValid },
  } = useForm<AddAffiliateValues>({
    defaultValues: {},
  });
  const _onClose = () => {
    reset();
    onClose();
  };
  return (
    <Modal
      size={"xl"}
      isOpen={isOpen}
      onClose={_onClose}
      closeOnOverlayClick={false}
    >
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>{"Create Affiliates"}</ModalHeader>
        <ModalBody>
          <Stack spacing={4}>
            <Text>You can create up to 100 affiliates per event.</Text>
            <Stack spacing={0}>
              <Text fontWeight={"medium"}>Quantity</Text>
              <HStack>
                <InputGroup w={"150px"} size={"md"}>
                  <Controller
                    control={control}
                    name="quantity"
                    render={({ field }) => (
                      <NumberInput
                        isDisabled={isLoading}
                        defaultValue={0}
                        value={field.value}
                        onChange={(number) =>
                          setValue(
                            "quantity",
                            number ? parseInt(number, 10) : 0,
                            {
                              shouldValidate: true,
                              shouldTouch: true,
                            }
                          )
                        }
                        min={0}
                        max={100 - data.affiliates.length}
                      >
                        <NumberInputField />
                        <NumberInputStepper>
                          <NumberIncrementStepper />
                          <NumberDecrementStepper />
                        </NumberInputStepper>
                      </NumberInput>
                    )}
                  />
                </InputGroup>
                <Text fontSize={"sm"} color="gray.500">
                  {100 - data.affiliates.length} remaining
                </Text>
              </HStack>
            </Stack>
          </Stack>
        </ModalBody>
        <ModalFooter>
          <Button isDisabled={isLoading} onClick={_onClose} mr="4">
            Cancel
          </Button>
          <Button
            isDisabled={!isValid}
            color="white"
            bg="green.500"
            isLoading={isLoading}
            onClick={handleSubmit(onCreateAffiliates)}
          >
            Create
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export default AddAffiliateModal;
